(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ggg-ebay-links"] && !Shopify.designMode) return;
  try {
    (() => {
    const destination = 'https://www.ebay.com/usr/ggg_2026';
    const storeHosts = new Set([location.hostname, 'graysgoodgoods.com', 'www.graysgoodgoods.com']);
    const shoppingPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:products|collections|cart|checkout|search)(?:\/|$)/i;
    function updateLink(anchor) {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      try {
        const url = new URL(href, location.href);
        if (storeHosts.has(url.hostname) && shoppingPath.test(url.pathname)) {
          anchor.setAttribute('href', destination);
        }
      } catch {}
    }
    function updateTree(root) {
      if (root instanceof Element && root.matches('a[href]')) updateLink(root);
      root.querySelectorAll?.('a[href]').forEach(updateLink);
    }
    function start() {
      updateTree(document);
      new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'attributes') updateLink(record.target);
          else record.addedNodes.forEach(updateTree);
        }
      }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
